import { useCallback, useEffect } from 'react';

const useOnClickOutside = (ref: any, callback: () => void) => {
    const fn = useCallback(
        (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        },
        [ref, callback],
    );

    useEffect(() => {
        window.addEventListener('click', fn);
        return () => window.removeEventListener('click', fn);
    }, [fn]);
};

export default useOnClickOutside;
